import { Colors } from '@vetahealth/fishing-gear/colors'
import { getDisplayValue } from '@vetahealth/fishing-gear/conversions'
import { DeviceStatusEnum, DeviceTypeEnum } from '@vetahealth/tuna-can-api'
import i18next from 'i18next'
import { DefaultTheme } from 'styled-components'

export const getDeviceName = (type: DeviceTypeEnum): string => {
  const deviceNames: Record<DeviceTypeEnum, string> = {
    [DeviceTypeEnum.BodytraceBpCuff]: i18next.t('devices.bodytraceBpCuff'),
    [DeviceTypeEnum.BodytraceScale]: i18next.t('devices.bodytraceScale'),
    [DeviceTypeEnum.GarminWatch]: i18next.t('devices.garminWatch'),
    [DeviceTypeEnum.GenericBpCuff]: i18next.t('devices.genericBpCuff'),
    [DeviceTypeEnum.GenericButton]: i18next.t('devices.genericButton'),
    [DeviceTypeEnum.GenericGlucometer]: i18next.t('devices.genericGlucometer'),
    [DeviceTypeEnum.GenericPulseOximeter]: i18next.t('devices.genericPulseOximeter'),
    [DeviceTypeEnum.GenericScale]: i18next.t('devices.genericScale'),
    [DeviceTypeEnum.SmartMeterIBloodPressure]: i18next.t('devices.smartMeterIBloodPressure'),
    [DeviceTypeEnum.SmartMeterIBloodPressureXl]: i18next.t('devices.smartMeterIBloodPressureXL'),
    [DeviceTypeEnum.SmartMeterIGlucose]: i18next.t('devices.smartMeterIGlucose'),
    [DeviceTypeEnum.SmartMeterIPulseOx]: i18next.t('devices.smartMeterIPulseOx'),
    [DeviceTypeEnum.SmartMeterIScale]: i18next.t('devices.smartMeterIScale'),
  }
  return deviceNames[type]
}

export const getOrderDeviceName = (type: DeviceTypeEnum, preferredWeightUnit: string): string => {
  const deviceNames: Record<DeviceTypeEnum, string> = {
    [DeviceTypeEnum.BodytraceBpCuff]: i18next.t('devices.bodytraceBpCuff'),
    [DeviceTypeEnum.BodytraceScale]: i18next.t('orderDevices.bodytraceScale', {
      valueAndUnit: getDisplayValue(440, 'lbs', 'weight', preferredWeightUnit),
    }),
    [DeviceTypeEnum.GarminWatch]: i18next.t('devices.garminWatch'),
    [DeviceTypeEnum.GenericBpCuff]: i18next.t('devices.genericBpCuff'),
    [DeviceTypeEnum.GenericButton]: i18next.t('devices.genericButton'),
    [DeviceTypeEnum.GenericGlucometer]: i18next.t('devices.genericGlucometer'),
    [DeviceTypeEnum.GenericPulseOximeter]: i18next.t('devices.genericPulseOximeter'),
    [DeviceTypeEnum.GenericScale]: i18next.t('devices.genericScale'),
    [DeviceTypeEnum.SmartMeterIBloodPressure]: i18next.t('devices.smartMeterIBloodPressure'),
    [DeviceTypeEnum.SmartMeterIBloodPressureXl]: i18next.t('devices.smartMeterIBloodPressureXL'),
    [DeviceTypeEnum.SmartMeterIGlucose]: i18next.t('devices.smartMeterIGlucose'),
    [DeviceTypeEnum.SmartMeterIPulseOx]: i18next.t('devices.smartMeterIPulseOx'),
    [DeviceTypeEnum.SmartMeterIScale]: i18next.t('orderDevices.smartMeterIScale', {
      valueAndUnit: getDisplayValue(550, 'lbs', 'weight', preferredWeightUnit),
    }),
  }
  return deviceNames[type]
}

export const getStatusLabel = (status: DeviceStatusEnum): string => {
  const statusColors: Record<DeviceStatusEnum, string> = {
    [DeviceStatusEnum.Created]: i18next.t('orderStatus.created'),
    [DeviceStatusEnum.Submitted]: i18next.t('orderStatus.submitted'),
    [DeviceStatusEnum.Fulfilled]: i18next.t('orderStatus.fulfilled'),
    [DeviceStatusEnum.Delivered]: i18next.t('orderStatus.delivered'),
    [DeviceStatusEnum.Returned]: i18next.t('orderStatus.returned'),
    [DeviceStatusEnum.Assigned]: i18next.t('orderStatus.assigned'),
    [DeviceStatusEnum.InUse]: i18next.t('orderStatus.inUse'),
  }
  return statusColors[status]
}

export const getStatusColor = (status: DeviceStatusEnum, theme: DefaultTheme): Colors | undefined => {
  if (!status) return
  const statusColors: Record<DeviceStatusEnum, Colors> = {
    [DeviceStatusEnum.Created]: theme.tagCreated,
    [DeviceStatusEnum.Submitted]: theme.tagSubmitted,
    [DeviceStatusEnum.Fulfilled]: theme.tagFullfilled,
    [DeviceStatusEnum.Delivered]: theme.tagDelivered,
    [DeviceStatusEnum.Returned]: theme.tagReturned,
    [DeviceStatusEnum.Assigned]: theme.tagAssigned,
    [DeviceStatusEnum.InUse]: theme.tagSuccess,
  }
  return statusColors[status]
}

export const getStatusDescription = (status: DeviceStatusEnum): string => {
  if (!status) return ''
  const statusDescription: Record<DeviceStatusEnum, string> = {
    [DeviceStatusEnum.Created]: i18next.t('orderStatus.description.created'),
    [DeviceStatusEnum.Submitted]: i18next.t('orderStatus.description.submitted'),
    [DeviceStatusEnum.Fulfilled]: i18next.t('orderStatus.description.fulfilled'),
    [DeviceStatusEnum.Delivered]: i18next.t('orderStatus.description.delivered'),
    [DeviceStatusEnum.Returned]: i18next.t('orderStatus.description.returned'),
    [DeviceStatusEnum.Assigned]: i18next.t('orderStatus.description.assigned'),
    [DeviceStatusEnum.InUse]: i18next.t('orderStatus.description.inUse'),
  }
  return statusDescription[status]
}

export const assignableDevices: DeviceTypeEnum[] = [
  DeviceTypeEnum.BodytraceBpCuff,
  DeviceTypeEnum.BodytraceScale,
  DeviceTypeEnum.GarminWatch,
  DeviceTypeEnum.GenericBpCuff,
  DeviceTypeEnum.GenericButton,
  DeviceTypeEnum.GenericGlucometer,
  DeviceTypeEnum.GenericPulseOximeter,
  DeviceTypeEnum.GenericScale,
  DeviceTypeEnum.SmartMeterIBloodPressure,
  DeviceTypeEnum.SmartMeterIBloodPressureXl,
  DeviceTypeEnum.SmartMeterIGlucose,
  DeviceTypeEnum.SmartMeterIPulseOx,
  DeviceTypeEnum.SmartMeterIScale,
]
